import { useRef, useEffect } from 'react';

export function useDebounceHandler<TValue = unknown>(handler: () => void, watchedValue: TValue, delay: number) {
    const firstRender = useRef(true);
    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return () => {};
        }
        const timeoutId = setTimeout(() => handler(), delay);
        return () => {
            clearTimeout(timeoutId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watchedValue, delay]);
}
